// Contract expected by @/mini/stores/auth.js (mini_vue's shared PKCE
// OAuth2 store) -- see that library's own CLAUDE.md.
const AUTH_SERVER_BASE = (import.meta.env.VITE_AUTH_SERVER_BASE || 'https://auth.uwa.agency').replace(/\/$/, '')

export const OAUTH_TOKEN_ENDPOINT = import.meta.env.VITE_OAUTH_TOKEN_ENDPOINT || `${AUTH_SERVER_BASE}/o/token/`
export const OAUTH_REVOKE_ENDPOINT = import.meta.env.VITE_OAUTH_REVOKE_ENDPOINT || `${AUTH_SERVER_BASE}/o/revoke_token/`
export const OAUTH_USERINFO_ENDPOINT = import.meta.env.VITE_OAUTH_USERINFO_ENDPOINT || `${AUTH_SERVER_BASE}/o/userinfo/`
export const OAUTH_AUTHORIZE_ENDPOINT = import.meta.env.VITE_OAUTH_AUTHORIZE_ENDPOINT || `${AUTH_SERVER_BASE}/o/authorize/`

// "JOPCO" OAuth2 Application registered on auth.uwa.agency 2026-09-16.
// Client id is a public identifier, safe to commit as a fallback default --
// same convention as jpm's/optcg-frontend's own config/auth.js. The client
// secret the auth server also issued deliberately never appears here (or
// anywhere in this repo): @/mini/stores/auth.js's flow is PKCE-only, and a
// secret embedded in shipped frontend JS would just be exposed to anyone
// who opens devtools, defeating its purpose.
export const OAUTH_CLIENT_ID = import.meta.env.VITE_OAUTH_CLIENT_ID || 'm7Fojh6OELovefs5Z2qBZKuQFEZarWr3XOzEUqwM'
export const OAUTH_CLIENT_SECRET = ''
export const OAUTH_SCOPE = import.meta.env.VITE_OAUTH_SCOPE || 'openid profile email'
